<template>
    <router-link
        :to="{ name: item.route }"
        class="py-2"
        :class="{ 'selected-route': isActiveRoute(item) }"
        :target="target">
        <span @click="onClick()" v-text="item.label"></span>
    </router-link>
</template>

<script>
export default {
    name: 'MenuItem',
    props: {
        item: {
            required: true,
            type: Object,
        },
    },
    computed: {
        iconUrl() {
            return require(`@/assets/images/user-menu/${this.item.icon}`);
        },
        target() {
            return this.item.target ? this.item.target : '_self';
        },
    },
    methods: {
        isActiveRoute(item) {
            return this.$route.name === item.route;
        },
        onClick() {
            this.$emit('menu');
        },
    },
};
</script>

<style scoped>
    .selected-route {
        padding: 10px 24px;
        border-radius: 136px;
        background-color: #ECE9E8;
    }
</style>
